import { render, staticRenderFns } from "./video.vue?vue&type=template&id=096d41c6&scoped=true&lang=pug&"
import script from "./video.vue?vue&type=script&lang=coffee&"
export * from "./video.vue?vue&type=script&lang=coffee&"
import style0 from "./video.vue?vue&type=style&index=0&id=096d41c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d41c6",
  null
  
)

export default component.exports